import { _get } from "./Axios";

export default class NotifikasiApi {

  static getList() {    
    let parameters = {
      page: 1,
      limit: 5,
      sort_by: 'created_at',
      sort_dir: 'desc',
    }
    let params = [];

    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    
    params = params.join("&");

    return _get(`notifications?${ params }`, null, true, true);
  }

  static getUnread() {
    return _get(`notifications/count`, null, true, true);
  }

  static setRead(id) {
    return _get(`notifications/${id}/read`, null, false, true);
  }
}
